import React from 'react';
import styled from 'styled-components';
import {COLORS} from '../../../constants/colors';
import {Icon} from '../../atoms/Icon/Icon';
import {GenericIconName} from '../../atoms/Icon/IconName';
import {Text} from '../../atoms/Text/Text';
import {ProductImage} from '../ProductImage/ProductImage';

interface GoBackWithProductImageProps {
  onClick: React.MouseEventHandler<HTMLElement> | undefined;
  headline: string;
  showProductName?: boolean;
  productSrc: string;
  productName: string;
  productAlt: string;
  isProductImageEnclosed?: boolean;
  testId?: string;
}

export const GoBackWithProductImage = ({
  onClick,
  headline,
  showProductName,
  productSrc,
  productName,
  productAlt,
  isProductImageEnclosed,
  testId,
}: GoBackWithProductImageProps) => {
  return (
    <Wrapper onClick={onClick} data-testid={testId}>
      <Icon asset={GenericIconName.ArrowLeft} size="S" />
      <ThumbnailContainer $padded={!!isProductImageEnclosed}>
        <ProductImage
          src={productSrc}
          alt={productAlt}
          padded={!!isProductImageEnclosed}
        />
      </ThumbnailContainer>
      <TitleWrapper>
        {!!showProductName && (
          <ProductName color="Grey1" size="px10">
            {productName}
          </ProductName>
        )}
        <Text
          color="Black"
          // When product name is shown, we need a smaller headline, because of spacing.
          // As of now, product name is shown only on mweb.
          size={showProductName ? 'px16' : 'px24'}
          weight="bold"
        >
          {headline}
        </Text>
      </TitleWrapper>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 17px;
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`;

const ProductName = styled(Text)`
  text-transform: uppercase;
`;

// Inspired and adjusted from offcanvas navigation thumbnails
const ThumbnailContainer = styled.div<{$padded: boolean}>`
  box-sizing: border-box;
  flex-shrink: 0;
  width: 40px;
  height: 54px;
  display: flex;
  align-items: center;
  justify-content: start;
  justify-content: center;
  background-color: ${COLORS.Grey4};
  border-radius: 4px;
  margin-right: 0.75rem;
  margin-left: 0.75rem;
`;
